import React, { Component } from 'react';
import { translate } from 'react-i18next';
import PropTypes from 'prop-types';
import b from 'b_';
import TroubleshootingInstructionsContent
    from '../TroubleshootingInstructionsContent/TroubleshootingInstructionsContent';
import './TroubleshootingInstructions.css';
import { isFuse5Enabled } from '../../../fuseFeatureFlag';
import OldTroubleshootingInstructions from './OldTroubleshootingInstructions';

const block = b.lock('NewTroubleshootingInstructions');

class NewTroubleshootingInstructions extends Component {
    static propTypes = {
        t: PropTypes.func.isRequired,
    };

    render() {
        const { t } = this.props;

        return <div className={block()}>
            <div className={block('Content')}>
                <TroubleshootingInstructionsContent t={t} />
            </div>
        </div>;
    }
}

const WrappedNewTroubleshootingInstructions = translate()(NewTroubleshootingInstructions);

const TroubleshootingInstructions = () => {
    return isFuse5Enabled() ? <WrappedNewTroubleshootingInstructions /> : <OldTroubleshootingInstructions />;
};

export default TroubleshootingInstructions;

